import type {
  ScorecardData,
  OverallEvaluationValue,
} from '@kula-ai/components';
import type { ScorecardType } from '@/types/interview';

/**
 * Maps a submitted/loaded `ScorecardType` to the kula-ai `ScorecardBuilder`
 * `data` shape for read-only VIEW. Answers come straight from the saved
 * scorecard; `yes_no` falls back to the default Yes/No options when none are
 * stored, and the rating string is narrowed to `OverallEvaluationValue` (our
 * rating values — strong_yes/yes/no/strong_no — already match that union).
 */
export const mapScorecardToData = (scorecard: ScorecardType): ScorecardData => {
  const {
    questions = [],
    feedback,
    feedback_description,
    rating,
    rating_description,
  } = scorecard ?? ({} as ScorecardType);

  return {
    questions: questions.map((question) => ({
      question: question.question,
      description: question.description,
      type: question.type,
      answer: question.answer,
      options:
        question.type === 'yes_no'
          ? (question.options ?? ['Yes', 'No'])
          : question.options,
      // Read-only view never shows the required asterisk (matches legacy UI).
      mandatory: false,
    })),
    feedback,
    feedbackDescription: feedback_description,
    rating: (rating || null) as OverallEvaluationValue | null,
    ratingDescription: rating_description,
  };
};
